import { Camera, Heart, Star } from "lucide-react";

const AboutSection = ({ isVisible }) => {
  return (
    <section
      id="about"
      className="py-24 lg:py-32 bg-[#FDFBF9]"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div
            className={`lg:col-span-5 ${
              isVisible ? "animate-fade-in-up" : "opacity-0"
            }`}
          >
            <div className="relative">
              <div className="img-hover-zoom">
                <img
                  src="https://customer-assets.emergentagent.com/job_relaxed-margulis-6/artifacts/c8r54yo7_IMG_6422.png"
                  alt="Brittany Bailey - Acadiana's Choice 2025 Winner, #1 Best Photographer of Acadiana"
                  className="w-full h-auto object-cover"
                />
              </div>
              {/* Decorative element */}
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#E2CCC2] -z-10" />
            </div>
          </div>

          {/* Content */}
          <div
            className={`lg:col-span-6 lg:col-start-7 ${
              isVisible ? "animate-fade-in-up animation-delay-200" : "opacity-0"
            }`}
          >
            <p className="overline text-[#C8A99C] mb-4">About Me</p>
            
            <h2 className="font-heading text-4xl lg:text-5xl font-light tracking-tight text-[#2C2A28] mb-6">
              Hey, I'm Brittany
            </h2>
            
            <div className="section-divider mb-8" />

            <p className="font-body text-sm font-medium text-[#C8A99C] mb-4 uppercase tracking-wide">
              Acadiana's Choice 2025 Winner — #1 Best Photographer & #1 Best Women-Owned Business
            </p>
            
            <p className="font-body text-[#5C5A56] leading-relaxed mb-6">
              Your go-to photographer in the Breaux Bridge & Lafayette area. I've spent the last 7+ years building a business I'm truly proud of, capturing everything from seniors to weddings to growing families.
            </p>
            
            <p className="font-body text-[#5C5A56] leading-relaxed mb-8">
              I'm all about real moments, natural vibes, and making your session feel fun instead of stressful. No stiff poses, no awkward energy — you'll feel like you've known me forever! I've built my business on relationships, trust, and going above and beyond for my clients.
            </p>

            {/* Stats/Features */}
            <div className="grid grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 bg-[#F5F2EB] rounded-full flex items-center justify-center">
                  <Camera size={24} className="text-[#C8A99C]" />
                </div>
                <p className="font-body text-2xl font-light text-[#2C2A28]">7+</p>
                <p className="font-body text-xs text-[#5C5A56] uppercase tracking-wide">Years</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 bg-[#F5F2EB] rounded-full flex items-center justify-center">
                  <Heart size={24} className="text-[#C8A99C]" />
                </div>
                <p className="font-body text-2xl font-light text-[#2C2A28]">500+</p>
                <p className="font-body text-xs text-[#5C5A56] uppercase tracking-wide">Sessions</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 bg-[#F5F2EB] rounded-full flex items-center justify-center">
                  <Star size={24} className="text-[#C8A99C]" />
                </div>
                <p className="font-body text-2xl font-light text-[#2C2A28]">5.0</p>
                <p className="font-body text-xs text-[#5C5A56] uppercase tracking-wide">Rating</p>
              </div>
            </div>

            <p className="font-heading text-xl italic text-[#2C2A28]">
              "If you're looking for someone who's going to hype you up AND deliver photos you're obsessed with… you found her."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
